import { motion, AnimatePresence } from "framer-motion";



const Modal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;

    return (
        <AnimatePresence>
            <motion.div
                className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 backdrop-blur-sm"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={onClose}
            >
                <motion.div
                    className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 relative"
                    initial={{ y: -30, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -30, opacity: 0 }}
                    transition={{ duration: 0.3, ease: "easeOut" }}
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* Close Button */}
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-red-500 transition-transform transform hover:scale-110 absolute top-4 right-4"
                    >
                        ✖
                    </button>

                    {/* Title */}
                    {title && <h3 className="text-2xl font-bold text-gray-900">{title}</h3>}

                    {/* Content */}
                    <div className="mt-4">{children}</div>

                    {/* Close Button */}
                    <button
                        onClick={onClose}
                        className="mt-6 w-full text-white bg-gradient-to-br from-red-600 to-pink-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 transition-all"
                        >
                        Close
                    </button>
                </motion.div>
            </motion.div>
        </AnimatePresence>
    );
};

export default Modal;